import React from "react";
import ActivityItem from "./ActivityItem";
import EmptyItem from "./EmptyItem";
import { TaskCard } from "./TaskCard";

const activityitem = (props: any) => <ActivityItem {...props} />;
const emptyitem = (props: any) => <EmptyItem {...props} />;
const taskcard = (props: any) => <TaskCard {...props} />;

const cardsRenderers = {
  activityitem,
  emptyitem,
  taskcard,
};

export default cardsRenderers;
